import {PayloadAction} from "../payload-action.interface";
import {NoteEntity} from "./note.entity";

export class NoteActions{
  static readonly ADD 		  = '[NoteActions] ADD';
  static readonly ADD_ALL 	= '[NoteActions] ADD_ALL';
  static readonly REMOVE 		= '[NoteActions] REMOVE';
  static readonly SET 		  = '[NoteActions] SET';

  static addAll(notes: Array<NoteEntity>): PayloadAction{
    return {
      type: NoteActions.ADD_ALL,
      payload: notes
    }
  }

  static add(note: NoteEntity): PayloadAction{
    return {
      type: NoteActions.ADD,
      payload: location
    }
  }

  static set(note: NoteEntity): PayloadAction{

    return {
      type: NoteActions.SET,
      payload: note
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: NoteActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/note/note.actions.ts